import { FeaturePageSection } from "@/features/feature-page/feature-page-section";
import { FeaturePageVisual } from "@/features/feature-page/feature-page-visual";
import type { ResolvedFeaturePageBlock } from "@garimpa/api/featurePages/types";

export function GalleryBlock({
  block,
}: {
  block: Extract<ResolvedFeaturePageBlock, { type: "gallery" }>;
}) {
  return (
    <FeaturePageSection block={block} resolvedBackground={block.resolvedBackground}>
      {block.heading ? (
        <h2
          id={`${block.id}-heading`}
          className="mb-10 text-center text-3xl font-bold tracking-tight sm:text-5xl"
        >
          {block.heading}
        </h2>
      ) : null}
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {block.items.map((item, index) => {
          const visual = block.resolvedItemVisuals?.[index];
          if (!visual) return null;
          return (
            <figure
              key={`${block.id}-${index}`}
              className="overflow-hidden rounded-2xl border border-border bg-card"
            >
              <FeaturePageVisual
                visual={visual}
                className="aspect-square h-auto w-full object-cover"
              />
              {item.caption || item.credit ? (
                <figcaption className="space-y-1 p-4 text-sm">
                  {item.caption ? <p>{item.caption}</p> : null}
                  {item.credit ? (
                    <p className="text-xs text-muted-foreground">{item.credit}</p>
                  ) : null}
                </figcaption>
              ) : null}
            </figure>
          );
        })}
      </div>
    </FeaturePageSection>
  );
}
